import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class MercadoriasClassificacaoService extends Service{

  protected url: string = this.dominio+"/adm/mercadorias/classificacao/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  ordenaIndices(indices){
    let headers = this.getHeaderLogado();

    return this.http.put(this.dominio + '/adm/fichas/indices-classificacao/ordenar', JSON.stringify(indices), {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/mercadorias-classificacao/mercadorias-classificacao.service.ts